<!-- 认款记账 subscriptionBookkeep -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign">
            </v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" :flagList="['payType'] " @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-select clearable size="mini" v-if="formOneValue.entityField == 'payType'" v-model="getRequestData[formOneValue.entityField]" placeholder="请选择">
                            <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                        </el-select>
                    </template>
                </vSearch>

            </div>
            <div v-if="returnData.list.length>0" style="font-size: 14px;text-align: right;">合计：<span style="color:red;font-size: 16px">{{ totalMoney }}</span></div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData.jurTableVo" @selection-change="handleSelectionChange" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%"
                      highlight-current-row size="mini">
                <el-table-column type="selection" width="50"></el-table-column>
                <!-- 主表单 -->
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip :min-width="tableValye.fieldWeight">
                        <template slot-scope="scope">
                            <!-- 开票日期 -->
                            <template v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </template>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                scope.row[tableValye.entityField] }}</a>
                            </span>
                            <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                            <span v-else>{{ scope.row[tableValye.entityField] }}</span>

                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>

        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="smId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <el-dialog v-if="dialogExcel" title="导入EXCEL" :visible.sync="dialogExcel" width="60%" :before-close="closeExcel">
            <compareUpload v-if="dialogExcel" :excelTable="importExcelTableName" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme
    },
    data() {
        //这里存放数据
        return {
            totalMoney: 0,
            tableHeight: 0,
            getRequestData: {
                "creater": '',
                "page": 1,
                "rows": 10,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
                cmName: '', //	付款方名称
                businessId: '', //	业务id
                cmId: '', //	客户id	
                coId: '', //	货主id
                coName: '', //	货主id
                payType: "",
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },
            buttonList: [],
            multipleSelection: [],
            pageShowData: [],
            formDataList: null,
            selectedDataIndex: 0,

            userOneList: [],
            seTitle: "", //检索
            DialogVisible: false,
            seWidth: '0',
            seId: 0,
            smId: 0,
            sField: '',
            requesUrl: "",
            ormId: "",
            dialogExcel: false,
            importType: 'PRODUCT',
            importExcelTableName: 'TMP_BT_PRODUCT',

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        'getRequestData.cmName': {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.getRequestData.cmId = ''
                }
            },
            deep: true,
        },
        'getRequestData.coName': {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.getRequestData.coId = ''
                }
            },
            deep: true,
        }
    },
    created() {
        this.requesUrl = this.$store.getters.getConfig.requestUrl;
        this.ormId = sessionStorage.getItem('ormId')
        this.getPageInfo()
    },
    //方法集合
    methods: {
        // 勾选明细
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //表格数据写入excel
        exportExcel(arrName, listName, title) {
            this.$common.exportData(this[arrName], this[listName], title)
        },
        // 记录汇总
        recordSummary(arrName, listName, title) {
            this.$refs.recordSummary.openBox(this[arrName], this[listName], title)
        },
        // 记录过滤
        recordFiltering(arrName, listName, title) {
            this.$refs.recordFiltering.openBox(this[arrName], this[listName], title)
        },
        closeExcel(refresh) {
            this.dialogExcel = false
            if (refresh) this.getDataList()
        },
        // 监听子组件   导入excel 成功
        fileSuccess(val) {
            console.log('fileSuccess', JSON.parse(JSON.stringify(val)));
        },
        // 导入EXCEL
        handleExcel() {
            this.dialogExcel = true;
        },

        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            // console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },

        isShowData(name, value) {
            switch (name) {
                case 'customerList':
                    var dataInfo = sessionStorage.getItem('selectCustomerData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.getRequestData.smId = dataInfo.smId
                        this.getRequestData.smName = dataInfo.smName
                    }

                    break;

                default:
                    this.getRequestData[name] = value

            }
        },
        //获取表头信息
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            })
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
                this.formDataList = this.pageShowData.jurTableVo
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                this.getButtonList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log('actionSet', actionData);
            switch (actionData.actionType) {
                case 4:
                    let sendData = JSON.parse(JSON.stringify(this.getRequestData))
                    sendData.ormId = this.ormId
                    window.location.href = this.requesUrl + `/ownerAccept/exportAccept${this.$common.getUrl(sendData)}`
                    break;
                case 7:
                    this.backKeep()
                    break;
                case 10:
                    this.ownerAcceptRedbash()
                    break;
                case 9:
                    window.location.href = this.requesUrl + `/runwater/importTemplate?ormId=${String(this.ormId)}`;
                    break;
                case 8://完成结算 Settlement
                    this.Settlement()
                    break;
            }
        },
        Settlement() {
            if (this.returnData.list.length < 1) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }
            if (this.multipleSelection.length != 1) {
                this.$message({
                    message: "请先选中一条数据操作",
                    type: "error",
                });
                return false;
            }
            this.$confirm("是否完成结算?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    const responseData = await this.$http.ownerAcceptIgnoreSettle({ ids: [this.multipleSelection[0].octId] });
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
        },
        async backKeep() {
            if (this.returnData.list.length < 1) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }

            if (this.multipleSelection.length < 1) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            let ids = []
            this.multipleSelection.forEach(v => {
                ids.push(v.octId)
            })

            this.$confirm("确定将选中回退吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: ids,
                    };
                    let responseData = await this.$http.ownerAcceptCallback(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },
        ownerAcceptRedbash() {
            if (this.returnData.list.length < 1) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }

            if (this.multipleSelection.length < 1) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            let ids = []
            this.multipleSelection.forEach(v => {
                ids.push(v.octId)
            })

            this.$confirm("确定将选中红冲吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: ids,
                    };
                    let responseData = await this.$http.ownerAcceptRedbash(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        showPrintPlan() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                var info = this.returnData.list[this.selectedDataIndex]
                this.$refs.printPlan.openDia(info.woamId)
            } else {
                return
            }
        },

        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        async getrunWaterMoney() {
            let responseData = await this.$http.ownerAcceptHisMoeny(this.getRequestData)
            // console.log(responseData);
            if (responseData && responseData.status == 200) {
                this.totalMoney = responseData.result

            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },

        // 获取数据列表
        async getDataList() {
            this.getrunWaterMoney()
            let responseData = await this.$http.ownerAcceptHis(this.getRequestData)
            // console.log(responseData);
            if (responseData && responseData.status == 200) {
                let resData = JSON.parse(JSON.stringify(responseData))
                this.returnData.list = resData.result.list
                this.returnData.pages = resData.result.pages
                this.returnData.total = resData.result.total
                this.returnData.pageNum = resData.result.pageNum
                this.selectedDataIndex = 0

            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },


        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
//获取状态
        getIsGsp(str, val) {
            try {
                str && str.replace(/\\/g, '')
                let arr = JSON.parse(str)
                let len = arr.length
                let newStr = ''
                for (let i = 0; i < len; i++) {
                    if (arr[i].key === val) {
                        newStr = arr[i].value
                        break;
                    }
                }
                return newStr
            } catch (ex) {
                return str
            }
        },

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped></style>